<template>
    <div class="app-secondary-container">
        <aside class="app-aside scrollfix">
            <div class="app-aside__content scrollfix">
                <unit-nav/>
            </div>
        </aside>
        <main class="app-main">
            <router-view/>
        </main>
    </div>
</template>
<script>
import UnitNav from '../components/Nav/UnitNav';

export default {
    components: {UnitNav},
    beforeMount() {
        this.$store.dispatch('projects/project/units/init')
    },
    beforeDestroy() {
        this.$store.dispatch('projects/project/units/reset')
    }
}
</script>
